/**
 * Short, human-readable form of a device's machine_id hash: the first 12 hex
 * characters, upper-cased and grouped in 4s (e.g. "AB78-16BF-8F01").
 *
 * This MUST match the desktop app's MachineIdentityHasher.ToDisplayId exactly, so
 * an admin can correlate a row here with the "This machine: …" id a user reads
 * off their own app (Menu ▸ Licence / About). The full 64-char hash is never
 * shown - it's a salted SHA-256 of the Windows MachineGuid (a pseudonymous id,
 * never the raw hardware value), and 12 hex chars is plenty to tell devices apart.
 */
export function deviceDisplayId(machineId: string | null | undefined): string {
  if (!machineId) return "unknown";
  const head = machineId.slice(0, 12).toUpperCase();
  return head.match(/.{1,4}/g)?.join("-") ?? head;
}
